function isPlainObject(value: unknown): value is Record<string, unknown> {
  if (value === null || typeof value !== "object") return false;
  const proto = Object.getPrototypeOf(value);
  return proto === Object.prototype || proto === null;
}

// Returns `next`, but every part of it deeply equal to the same part of `prev` is
// `prev`'s object, so consumers comparing by reference see only what really changed.
export function structuralShare<T>(prev: unknown, next: T): T {
  if (Object.is(prev, next)) return next;

  if (Array.isArray(prev) && Array.isArray(next)) {
    const shared = next.map((item, i) => structuralShare(prev[i], item));
    const same = shared.length === prev.length && shared.every((item, i) => item === prev[i]);
    return (same ? prev : shared) as T;
  }

  if (isPlainObject(prev) && isPlainObject(next)) {
    const keys = Object.keys(next);
    const shared: Record<string, unknown> = {};
    for (const key of keys) shared[key] = structuralShare(prev[key], next[key]);
    const same = keys.length === Object.keys(prev).length && keys.every((key) => key in prev && shared[key] === prev[key]);
    return (same ? prev : shared) as T;
  }

  return next;
}
